import { createAccountUrl } from "./constants"
import { getAccessToken } from "@/utils/helper"
import { apiBaseUrl } from "@/constants/index"
import { apim } from "@/constants/api"

export const registerUserOKTA = async ({ number, anonymousId = null }) => {
  let accessToken = null
  accessToken = getAccessToken()?.token
  return new Promise(async (resolve, reject) => {
    try {
      const body = {
        login: number,
      }
      if (anonymousId) {
        body["anonymous-id"] = anonymousId
      }
      const { data: content } = await apim.post(
        `${apiBaseUrl}${createAccountUrl}?stage=initial`,
        body
      )
      resolve(content)
    } catch (error) {
      reject(error)
    }
  })
}

export const activateUserFactor = async payload => {
  let accessToken = null
  accessToken = getAccessToken()?.token
  return new Promise(async (resolve, reject) => {
    try {
      const body = payload
      const { data: content } = await apim.post(
        `${apiBaseUrl}/customer/factor/activate`,
        body
      )
      resolve(content)
    } catch (error) {
      reject(error)
    }
  })
}

export const updateUserOKTA = async payload => {
  let accessToken = null
  accessToken = getAccessToken()?.token
  return new Promise(async (resolve, reject) => {
    try {
      const body = {
        firstName: payload?.fname,
        lastName: payload?.lname,
        email: payload?.email,
        login: payload?.login,
        mobile: payload?.mobile,
        oktaId: payload?.id,
      }
      const { data: content } = await apim.post(
        `${apiBaseUrl}${createAccountUrl}?stage=update`,
        body
      )
      resolve(content)
    } catch (error) {
      reject(error)
    }
  })
}
